import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import { LayoutDashboard, Package, Sliders, MessageSquare, Tag, Users, BookOpen, Layers, LogOut, Receipt } from "lucide-react";

const links = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/products", label: "Prodotti", icon: Package },
    { to: "/admin/collections", label: "Collezioni", icon: Layers },
    { to: "/admin/homepage", label: "Homepage", icon: Sliders },
    { to: "/admin/orders", label: "Ordini", icon: Receipt },
    { to: "/admin/reviews", label: "Recensioni", icon: MessageSquare },
    { to: "/admin/discounts", label: "Sconti", icon: Tag },
    { to: "/admin/customers", label: "Clienti", icon: Users },
    { to: "/admin/blog", label: "Blog", icon: BookOpen },
];

export default function AdminLayout() {
    const { user, authLoading, logout } = useApp();
    const navigate = useNavigate();

    if (authLoading) return <div className="min-h-screen bg-[color:var(--ms-ivory)] text-[color:var(--ms-muted)] p-10">Caricamento…</div>;
    if (!user || user.role !== "admin") {
        return (
            <div className="min-h-screen bg-[color:var(--ms-ivory)] flex items-center justify-center px-6" data-testid="admin-unauthorized">
                <div className="panel p-10 max-w-md text-center">
                    <div className="overline mb-3">Area riservata</div>
                    <h1 className="font-display text-3xl text-[color:var(--ms-charcoal)]">Accesso Admin</h1>
                    <p className="text-[color:var(--ms-muted)] text-sm mt-3">Accedi con un account amministratore per continuare.</p>
                    <Link to="/admin/login" className="inline-block mt-6 bg-[color:var(--ms-charcoal)] text-[color:var(--ms-warm-white)] px-6 py-3 text-xs tracking-[0.22em] uppercase hover:bg-[color:var(--ms-sage-dark)] transition-colors">Login Admin</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[color:var(--ms-ivory)] grid md:grid-cols-[240px_1fr]">
            <aside className="border-r border-[color:var(--ms-border)] bg-[color:var(--ms-cream)] flex flex-col">
                <div className="p-6 border-b border-[color:var(--ms-border)]">
                    <div className="overline">Admin</div>
                    <Link to="/" className="font-display font-italic-display text-2xl text-[color:var(--ms-charcoal)] hover:text-[color:var(--ms-sage-dark)]">Mini Style</Link>
                </div>
                <nav className="flex-1 p-3 space-y-1">
                    {links.map(l => {
                        const Icon = l.icon;
                        return (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.end}
                                className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-[color:var(--ms-warm-white)] text-[color:var(--ms-sage-dark)] font-medium" : "text-[color:var(--ms-charcoal)] hover:bg-[color:var(--ms-warm-white)] hover:text-[color:var(--ms-sage-dark)]"}`}
                                data-testid={`admin-nav-${l.label.toLowerCase()}`}
                            >
                                <Icon size={16} /> {l.label}
                            </NavLink>
                        );
                    })}
                </nav>
                <button onClick={async () => { await logout(); navigate("/admin/login"); }} className="m-3 px-3 py-2.5 text-sm text-[color:var(--ms-charcoal)] hover:text-[color:var(--ms-terracotta)] flex items-center gap-3 border border-[color:var(--ms-border)] hover:border-[color:var(--ms-terracotta)] transition-colors" data-testid="admin-logout">
                    <LogOut size={16} /> Esci
                </button>
            </aside>
            <section className="p-8 md:p-12 overflow-x-hidden">
                <Outlet />
            </section>
        </div>
    );
}
